var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Wrapper',[_c('div',{staticClass:"desc"},[_vm._v(" 抗憂鬱食物記憶大考驗！成功將2張抗憂鬱食物卡牌配對，即可得1分，愈快完成答題，分數再加碼，歡迎挑戰高分！ ")]),_c('div',{staticClass:"button",on:{"click":function($event){return _vm.$emit('ready')}}},[_vm._v("Ready")])])}
var staticRenderFns = []

export { render, staticRenderFns }